import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signin from "./components/Signin";
import MarketingPage from "../src/MarketingPage";
import SidbarPage from "./components/SidbarPage";
import HomeDashboard from "./childcomponents/Dashboard/HomeDashboard";
import LegalAssistant from "./childcomponents/Dashboard/LegalAssistant";
import LegalResearch from "./childcomponents/Dashboard/LegalResearch";
import LegalQuestionAndAnsers from "./childcomponents/Dashboard/LegalQuestionAndAnsers";
import LegalSummary from "./childcomponents/Dashboard/LegalSummary";
import LegalAnalyzer from "./childcomponents/Dashboard/LegalAnalyzer";
import { ToastContainer } from "react-toastify";
import Loader from "./Loader/loader";
import useAxiosInterceptors from "./axiosInstance";
import LegalAnalyzerQuestions from "./childcomponents/LegalResearch/LegalAnalyzerQuestions";
import Demo from "./components/demo";

function App() {
    useAxiosInterceptors(); // Set up interceptors when the app mounts

    return (
    <>
      <Loader />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Router>
        <Routes>
          <Route path="/" element={<MarketingPage />} />
          <Route path="/login" element={<Signin />} />
          <Route path="/get-demo" element={<Demo />} />
          <Route path="/dashboard" element={<SidbarPage />}>
            <Route index element={<HomeDashboard />} />
            <Route path="legal-assistant" element={<LegalAssistant />} />
            <Route path="legal-Q&A" element={<LegalQuestionAndAnsers />} />
            <Route path="legal-summary" element={<LegalSummary />} />
            <Route path="legal-analyzer" element={<LegalAnalyzer />} />
            <Route path="legal-research" element={<LegalResearch />} />
            <Route path="legal-analyzer-question" element={<LegalAnalyzerQuestions />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
